import prisonersFa from './fa/fa.json'

const prisonersMessages = {
  fa: { ...prisonersFa },
}

export default prisonersMessages
